module.exports = __webpack_public_path__ + "static/media/fieldviewer.bcf86244.png";